const resources = {
    usName: 'États-Unis',
    caName: 'Canada',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    address2Label: 'Avertisseur de porte, code du bâtiment, numéro d’app... etc.',
    add: 'Ajouter',
    country: 'Pays',
    streetAddress: 'Adresse',
    address: 'Adresse',
    address2: 'Ligne d’adresse 2',
    startTyping: 'Commencez à entrer votre adresse',
    city: 'Ville',
    phone: 'Téléphone',
    phoneNumber: 'Numéro de téléphone',
    postalCode: 'Code postal',
    zipPostalCode: 'Code postal',
    emailAddress: 'Adresse de courriel',
    enterZipCodeText: 'Saisir un code ZIP/postal pour voir la ville et l’État/la région.',
    region: 'Région',
    stateRegion: 'État/Région',
    province: 'Province',
    emailRequiredText: 'Vous devez fournir votre adresse courriel pour recevoir les notifications d’expédition et suivre votre commande.',
    optional: '(facultatif)',
    phoneContext: '(pour les questions sur la livraison)',
    keepTyping: 'Continuez à taper, indiquez aussi le numéro d’appartement, du bureau et du bâtiment'
};

export default function getResource(label) {
    return resources[label];
}
